export const ESTIMATED_HOURS_MAX = 99999999;
export const ADD_TASK_RESOURCE_ESTIMATE_DIALOG_SETTING =
  'add_task_resource_estimate_dialog_setting';
export const ADD_RESOURCE_ESTIMATE_DIALOG_TABS = {
  PLACEHOLDER: 'placeholder',
  RESOURCE: 'resource'
};
